import { useEffect } from 'react';
import I18N from '@leverege/i18n';
import { Button, Dialogs } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { GroupDelegate } from '@leverege/molten/imagine';
import PositionPendingDialog from './PositionPendingDialog';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('recovr.actions.positionPending.PositionPendingButton');
const getActions = actions => {
  return new GroupDelegate({
    ...actions,
    queryName: 'positionPendingCounter'
  });
};
function PositionPendingButton({
  context
}) {
  const {
    objectType,
    data,
    actions
  } = context.clientProps;
  let field;
  if (objectType === 'vehicle') {
    field = 'data/locator/data/locatorAlerts@/[positionPending]';
  } else {
    field = 'data/locatorAlerts@/[positionPending]';
  }
  useEffect(() => {
    GlobalState.dispatch(getActions(actions).search({
      limit: 0,
      aggs: {
        positionPendingAgg: {
          type: 'filter',
          filter: {
            field,
            type: 'equals',
            value: true
          }
        }
      }
    }));
  }, [data, field, actions]);
  const list = getActions(context.clientProps.actions).getList(GlobalState.get());
  const numPending = list?.aggs?.positionPendingAgg?.count;
  if (!list || !numPending) {
    return null;
  }
  const positionsWord = numPending === 1 ? 'Position' : 'Positions';
  const onClick = () => {
    Dialogs.show({
      component: PositionPendingDialog,
      props: {
        context,
        numPending
      }
    });
  };
  return /*#__PURE__*/_jsx(Button, {
    icon: t('icon'),
    variant: "tertiary",
    onClick: onClick,
    children: t('buttonText', {
      numPending,
      positionsWord
    })
  });
}
export default PositionPendingButton;